// extracted by mini-css-extract-plugin
module.exports = {"container":"giant-button-module--container--1s0Wi","link":"giant-button-module--link--1DNc8","icon":"giant-button-module--icon--1xnMu"};